import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";

import Banner from "./../banner/banner";
import * as api from "./../../api/api";

import LeftSponsors from "./../leftSponsers/leftSponsers";
import TextField from "@material-ui/core/TextField";

//BACKDROP STYLING
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import * as Moment from "moment";

var currentDate = Moment("2022-03-11");
var futureYears = Moment(currentDate).add(1, "Y");

const initialFormData = {
  company_id: null,
  publication_type_id: null,
  category_id: null,
  starting_date: Moment(new Date()).format("YYYY-MM-DD"),
  ending_date: Moment(futureYears).format("YYYY-MM-DD"),
  key_word: null,
};

console.log("initialFormData", initialFormData.ending_date);

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
    backgroundColor: "white",
  },
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
}));

export default function NewsAndFeatures() {
  const classes = useStyles();
  const history = useHistory();
  const [loader, setLoader] = useState(true);

  const [formData, setFormData] = useState(initialFormData);
  const [banner, setBanner] = useState("");
  useEffect(async () => {
    document.title = "121five.com - Search News & Features";
    window.scrollTo(0, 0);
    // typeApi();
    // companyApi();
    // categoryApi();
    let res = await api.banner(2);
    if (res) {
      setBanner(res.image);
    }
    setLoader(false);
  }, []);

  // const typeApi = async () => {
  //   try {
  //     let response = await api.type();
  //     setType(response.data);
  //   } catch (e) {
  //
  //   }
  // };

  // const companyApi = async () => {
  //   try {
  //     let response = await api.company();
  //     setCompany(response);
  //   } catch (e) {
  //
  //   }
  // };

  // const categoryApi = async () => {
  //   try {
  //     let response = await api.category();
  //     setCategory(response.data);
  //   } catch (e) {
  //
  //   }
  // };

  const onChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async () => {
    const {
      company_id,
      category_id,
      publication_type_id,
      starting_date,
      ending_date,
      key_word,
    } = formData;
    try {
      const requestObj = {
        // company_id: "1",
        category_id: category_id ? category_id : null,
        publication_type_id: "1",
        starting_date: starting_date ? starting_date : null,
        ending_date: ending_date ? ending_date : null,
        key_word: key_word ? key_word : null,
      };
      history.push({
        pathname: "/results",
        state: {
          data: requestObj,
        },
      });
    } catch (e) {}
  };

  return (
    <div>
      <Banner img={banner} />
      <section className="sponsor py-5">
        <div className="container">
          <div className="row justify-content-lg-between justify-content-center">
            <div className="col-lg-3 col-md-6">
              <div className="left-sponsor">
                <LeftSponsors />
              </div>
            </div>
            <div className="col-lg-9 col-md-12">
              <div className="search-form">
                <h4>Search News Stories & Feature Articles</h4>
                <p>Please enter your search criteria below</p>
                <form>
                  {/* COMPANY NAME */}
                  {/* <div className="form-group">
                    <label for="company">Company Name:</label>
                    <select
                      className="form-control"
                      id=""
                      name="company_id"
                      onChange={onChange}
                    >
                      <option disabled selected>
                        Company Name
                      </option>
                      {Object.keys(company).map((index) => {
                        return (
                          <option value={company[index].id}>
                            {company[index].name}
                          </option>
                        );
                      })}
                    </select>
                  </div> */}

                  {/* PUBLICATION TYPE */}
                  {/* <div className="form-group">
                    <label for="company">Publication Type :</label>
                    <select
                      className="form-control"
                      name="publication_type_id"
                      onChange={onChange}
                    >
                      <option disabled selected>
                        Publication Type
                      </option>
                      <option value="0">All</option>
                      {Object.keys(type).map((index) => {
                        return (
                          <option value={type[index].id}>
                            {type[index].name}
                          </option>
                        );
                      })}
                    </select>
                  </div> */}

                  <div className="form-group">
                    <label for="">Date Range :</label>
                    <br />
                    <TextField
                      id="date"
                      // label="from"
                      type="date"
                      value={formData.starting_date}
                      className={`${classes.textField} form-control`}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      name="starting_date"
                      onChange={onChange}
                    />

                    <TextField
                      id="date"
                      // label="from"
                      type="date"
                      value={formData.ending_date}
                      className={`${classes.textField} form-control`}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      name="ending_date"
                      onChange={onChange}
                    />
                  </div>
                  {/* <div className="form-group">
                    <label for="company">Category :</label>
                    <select
                      className="form-control"
                      id=""
                      name="category_id"
                      onChange={onChange}
                    >
                      {Object.keys(category).map((index) => {
                        return (
                          <option value={category[index].id}>
                            {category[index].name}
                          </option>
                        );
                      })}
                    </select>
                  </div> */}
                  <div className="form-group">
                    <label for="kewword">Search By</label>
                    <input
                      type="text"
                      className="form-control"
                      id=""
                      aria-describedby=""
                      name="key_word"
                      onChange={onChange}
                    />
                  </div>
                </form>
                <button
                  type="submit"
                  className="search-btn submitForm hvr-sweep-to-right"
                  onClick={handleSubmit}
                >
                  Search
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Backdrop className={classes.backdrop} open={loader}>
        <CircularProgress />
      </Backdrop>
    </div>
  );
}
